import * as React from "react";
import classnames from "classnames";
/* empty css                          */
const ProductBlockGridCell = ({
  children,
  isWide = false
}) => /* @__PURE__ */ React.createElement(
  "div",
  {
    className: classnames("product-block-grid-cell", {
      "product-block-grid-cell--wide": isWide
    }),
    "data-t": "product-block-grid-cell"
  },
  children
);
export {
  ProductBlockGridCell
};
//# sourceMappingURL=ProductBlockGridCell.js.map
